import React from "react"
import { Box } from "@mui/material"
import StaffPerformanceReportContentCP from "../components/staff-performance-report-content.cp"

export default function StaffPerformanceReportPage() {
  return (
    <Box sx={{ p: 3 }}>
      <StaffPerformanceReportContentCP />
    </Box>
  )
}
